module.exports = __webpack_public_path__ + "img/17a003-16.909fea7c.jpg";